import { Page, Zone } from '@gimlite/ui-v1';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { iconGlobalEntity } from '../../common/mapper/icon.mapper';
import { BreakdownsDetails } from '../../composition/details/breakdown.details';
import { BreakdownList } from '../../composition/list/breakdown.list';
import { useMyUrl, useTranslation } from '@gimlite/common';

export const BreakdownsPage = observer(() => {
  const navigate = useNavigate();
  const { getParamsUrlString } = useMyUrl({});
  const { t } = useTranslation();
  const { parkingId, breakdownId } = useParams();
  const [selected, setSelected] = useState<string | null>(breakdownId || null);

  useEffect(() => {
    if (selected) {
      navigate(`/${parkingId}/breakdowns/${selected}?${getParamsUrlString}`);
    }
  }, [selected]);

  useEffect(() => {
    setSelected(null);
  }, [parkingId]);

  return (
    parkingId && (
      <Page>
        <Zone
          config={{
            zones: [['list', 'details']],
            rows: ['1fr'],
            columns: ['1fr', '1fr'],
          }}
        >
          <Zone.Area
            config={{
              area: 'list',
            }}
          >
            <BreakdownList
              widget={{
                title: t('listOfDeviceFailures'),
                icon: iconGlobalEntity['breakdown'],
              }}
              parkingId={parkingId}
              setSelectedBreakdown={setSelected}
            />
          </Zone.Area>

          <Zone.Area
            config={{
              area: 'details',
            }}
          >
            <BreakdownsDetails
              widget={{ title: t('detailsOfDeviceFailure') }}
              breakdownId={selected}
            />
          </Zone.Area>
        </Zone>
      </Page>
    )
  );
});
